import '_u/vconsole'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Bus from '_u/bus'
import Request from '@/api'
import Moment from '_u/moment'
import Head from '_c/head'
import Kefu from '_c/kefu'
import { Image, Button, Row, Col, Icon, Toast, Popup, Picker, Dialog } from 'vant'
import { Form, Field, Radio, Checkbox, Tabbar, TabbarItem } from 'vant'
import { Tab, Tabs, Cell, CellGroup, Empty, Loading } from 'vant'
Vue.use(Icon).use(Row).use(Col).use(Image).use(Button).use(Popup).use(Picker).use(Dialog)
Vue.use(Form).use(Field).use(Radio).use(Checkbox).use(Tabbar).use(TabbarItem)
Vue.use(Tab).use(Tabs).use(Cell).use(CellGroup).use(Moment).use(Empty).use(Loading)
Vue.component('Head', Head)
Vue.component('Kefu', Kefu)
Toast.setDefaultOptions({ duration: 2500 })

Vue.prototype.$toast = Toast
Vue.prototype.$request = Request
Vue.prototype.$bus = Bus
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
